import { render, staticRenderFns } from "./FavoriteCell.vue?vue&type=template&id=8d8613c8&scoped=true"
import script from "./FavoriteCell.vue?vue&type=script&lang=js"
export * from "./FavoriteCell.vue?vue&type=script&lang=js"
import style0 from "./FavoriteCell.vue?vue&type=style&index=0&id=8d8613c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8613c8",
  null
  
)

export default component.exports